// extracted by mini-css-extract-plugin
export var active = "_2q-9";
export var backButton = "_2q-8";
export var clone = "_2q-e";
export var collapseBar = "_2q-k";
export var collapseMode = "_2q-m";
export var collapsed = "_2q-o";
export var dimmed = "_2q-i";
export var dragHandle = "_2q-c";
export var dropdownIcon = "_2q-g";
export var expanding = "_2q-n";
export var hidden = "_2q-x";
export var iconContainer = "_2q-q";
export var iconSwapper = "_2q-w";
export var navItem = "_2q-6";
export var navItemIcon = "_2q-f";
export var navProfile = "_2q-7";
export var notificationCountBadge = "_2q-j";
export var notificationDot = "_2q-r";
export var optionsContainer = "_2q-h";
export var primaryNav = "_2q-0";
export var primaryNavDivider = "_2q-v";
export var primaryNavResizeHandle = "_2q-2";
export var primaryNavResizing = "_2q-1";
export var primaryNavTabSection = "_2q-u";
export var primaryTab = "_2q-p";
export var primaryTabIconBox = "_2q-s";
export var secondaryNav = "_2q-3";
export var selected = "_2q-t";
export var settingsNav = "_2q-4";
export var settingsNavItems = "_2q-5";
export var show = "_2q-d";
export var sideNav = "_2q-l";
export var teamItem = "_2q-a";
export var userProfileItem = "_2q-b";